import { Avatar, Flex } from 'antd'
import React from 'react'
import { DesignSystem } from '~/core/designSystem'
import { UIChatReaction } from '../../types'

type Props = {
  reactions: UIChatReaction[]
}

export const RenderReactions: React.FC<Props> = ({ reactions = [] }) => {
  return (
    <>
      {reactions.length > 0 && (
        <Flex wrap gap={8} className="py-1">
          <Avatar.Group>
            {reactions.map(reaction => (
              <Avatar
                key={reaction}
                style={{
                  background: 'white',
                  border: `1px solid ${DesignSystem.ThemeConst.CONSUMER_LIGHTGREY}`,
                  fontSize: '11px',
                }}
                size={24}
              >
                {reaction}
              </Avatar>
            ))}
          </Avatar.Group>
        </Flex>
      )}
    </>
  )
}
